import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectEncumbranceRealtyFilter } from 'shared/selectors/advancedFilters';

export const EncumbranceRealtyContainer: FC = () => {
  const { label, value, options } = useSelector(selectEncumbranceRealtyFilter);

  const onChange = useFilterChangeCallback();

  const handleEncumbranceRealtyChange = useCallback(
    (newValue: boolean | null) => {
      onChange({ action: 'setIsEncumbranceRealty', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <SingleSelectionAdvancedFilter value={value} options={options} onFilterChange={handleEncumbranceRealtyChange} />
    </AdvancedFilterRow>
  );
};
